import { APP_INITIALIZER, ApplicationConfig, provideBrowserGlobalErrorListeners } from '@angular/core';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { provideRouter } from '@angular/router';
import { credentialsInterceptor } from './core/interceptors/credentials.interceptor';
import { httpErrorInterceptor } from './core/interceptors/http-error.interceptor';
import { AuthService } from './core/services/auth.service';
import { routes } from './app.routes';

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideRouter(routes),
    provideHttpClient(withInterceptors([credentialsInterceptor, httpErrorInterceptor])),
    {
      provide: APP_INITIALIZER,
      useFactory: (auth: AuthService) => async () => {
        await auth.ensureCsrfCookie();
        await auth.checkSession();
      },
      deps: [AuthService],
      multi: true,
    },
  ],
};
